import React from "react";

import { useTranslation } from "react-i18next";

import styles from "./ContentsTitle.module.scss";

type Props = {
  title: string;
};

const ContentsTitle: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation();
  return (
    <h2 className={styles["c-contents__title"]}>
      <span className={styles["c-contents__title-text"]}>
        {t(title)}
      </span>
    </h2>
  );
};

export default ContentsTitle;
